module.exports = __webpack_public_path__ + "static/category-accessories-c364613684e9fcc6fc78fed1a4de72f8.jpg";